import { List, Map, Record } from 'immutable';


const CompanyRecord = Record({
    activeSubscription: Map(),
    activeSyndicationCount: 0,
    balance: Map({
        available: 0,
        held: 0,
        pending: 0,
    }),
    boostsUsedThisPeriod: 0,
    campaignCount: 0,
    campaigns: List(),
    cardBrand: null,
    cardLastFour: null,
    cardVerified: false,
    costPerRebate: 0,
    flags: List(),
    hasCard: null,
    id: null,
    isSubscribed: null,
    keywordTrackingLimit: 0,
    metadata: Map(),
    name: '',
    nonRenewal: false,
    paymentMethod: null,
    rebateCap: 0,
    remainingBoosts: 0,
    remainingKeywords: 0,
    remainingVideoShorts: 0,
    stripeId: null,
    trialEndsAt: null,
    unusedFeatures: 0,
    users: List(),
});

function getHasBetaAccess() {
    return this.getIn(['metadata', 'hasBetaAccess'], false);
}

CompanyRecord.prototype.getHasBetaAccess = getHasBetaAccess;

export default CompanyRecord;
